export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidUrl = (url: string): boolean => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // Protocol (http or https), optional now
      '([a-zA-Z\\d.-]+)' + // Domain
      '(\\.[a-zA-Z]{2,})' // Upper level domain
  );

  return !!urlPattern.test(url);
};
